import { render, staticRenderFns } from "./cardMarketing.vue?vue&type=template&id=19e2061e&scoped=true&"
import script from "./cardMarketing.vue?vue&type=script&lang=js&"
export * from "./cardMarketing.vue?vue&type=script&lang=js&"
import style0 from "./cardMarketing.vue?vue&type=style&index=0&id=19e2061e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19e2061e",
  null
  
)

export default component.exports